/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */

/**
 * 'FAILED' replays post-processing on the stored transcript (steps that already succeeded skip themselves). 'ALL' re-sources the transcript and re-runs extraction + scoring from scratch. 'RESEND' only re-dispatches the completion webhook.
 */
export type CreateBulkReprocessRunDtoMode = typeof CreateBulkReprocessRunDtoMode[keyof typeof CreateBulkReprocessRunDtoMode];


export const CreateBulkReprocessRunDtoMode = {
  FAILED: 'FAILED',
  ALL: 'ALL',
  RESEND: 'RESEND',
} as const;
